import { useAuthStore } from "store/authentication";

const CHAT_WIDGET_URL =
  "https://alicia-insurance.personastudios.ai/chat-widget.js";

const CHAT_WIDGET_ID = "ps-chat-widget-script";

export const usePersonaStudio = () => {
  const { user } = useAuthStore();

  const setUserDetails = () => {
    window.PSChatConfig = {
      hiddenButton: true,
      name: user?.first_name !== "" ? user?.first_name : "",
      email: user?.first_name !== "" ? user?.email : "",
    };
  };

  const toggleChatWidget = () => {
    const psChatWidget = window.PSChatWidget;
    if (psChatWidget && typeof psChatWidget.toggleChatWidget === "function") {
      setUserDetails();
      psChatWidget.toggleChatWidget();
    }
  };

  const initPersonaStudio = () => {
    if (document.getElementById(CHAT_WIDGET_ID)) {
      return;
    }

    setUserDetails();
    const scriptElement = document.createElement("script");
    scriptElement.id = CHAT_WIDGET_ID;
    scriptElement.type = "text/javascript";
    scriptElement.async = true;
    scriptElement.crossOrigin = "anonymous";
    scriptElement.src = CHAT_WIDGET_URL;
    document.body.appendChild(scriptElement);
  };

  return {
    initPersonaStudio,
    toggleChatWidget,
  };
};
